import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/Tx_CompareForms/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/Tx_CompareForms/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/Tx_CompareForms/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/Tx_CompareForms/Save',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/Tx_CompareForms/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/Tx_CompareForms/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/Tx_CompareForms/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}

// 更新状态
export function AsyncCompareForm() {
  return request({
    url: '/Tx_CompareForms/AsyncCompareForm',
    method: 'get'
  });
}

// 更新状态
export function AsyncCompareFormFalse(data) {
  return request({
    url: '/Tx_CompareForms/AsyncCompareFormFalse',
    method: 'post',
    data: { paramStr: data }
  });
}

// 二次报价
export function BeginSecondPrice(data) {
  return request({
    url: '/Tx_CompareForms/BeginSecondPrice',
    method: 'post',
    data
  });
}

// 二次报价结束
export function FinishSecondPrice(keyValue) {
  return request({
    url: '/Tx_CompareForms/FinishSecondPrice',
    method: 'get',
    params: { keyValue: keyValue }
  });
}

// 提交
export function Commit(data) {
  return request({
    url: '/Tx_CompareForms/Commit',
    method: 'post',
    data: { paramStr: data }
  });
}

// 审核
export function Approve(keyValue) {
  return request({
    url: '/Tx_CompareForms/Approve',
    method: 'get',
    params: { keyValue: keyValue }
  });
}

export function dels(data) {
  return request({
    url: '/Tx_CompareForms/Delete',
    method: 'get',
    params: data
  });
}
